import { BaseFetch } from "../main-model"
export default class CommanBudYearModel extends BaseFetch {
  getCommanBudYearBy = (data) =>
    this.authFetch({
      url: "comman-bud-year/getCommanBudYearBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getCommanBudYearById = (data) =>
    this.authFetch({
      url: "comman-bud-year/getCommanBudYearById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateCommanBudYearById = (data) =>
    this.authFetch({
      url: "comman-bud-year/updateCommanBudYearById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertCommanBudYear = (data) =>
    this.authFetch({
      url: "comman-bud-year/insertCommanBudYear",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteCommanBudYearById = (data) =>
    this.authFetch({
      url: "comman-bud-year/deleteCommanBudYearById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
